import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import KnowledgeBaseAPI from '../../api/knowledgeBase';

const state = {
  records: [],
  selectedArticle: {},
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getKnowledgeBaseRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSelectedArticle(_state) {
    return _state.selectedArticle;
  },
};

const actions = {
  getKnowledgeBaseRecords: async function getKnowledgeBaseRecords(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { fetchingList: true });
    try {
      const response = await KnowledgeBaseAPI.get({ searchKey });
      commit(types.default.SET_KNOWLEDGE_BASE, response.data);
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { fetchingList: false });
    } catch (error) {
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { fetchingList: false });
    }
  },

  createKnowledgeBaseArticle: async function createCannedResponse(
    { commit },
    articleObj
  ) {
    commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { creatingItem: true });
    try {
      const payload = {
        knowledge_base: articleObj,
      };
      const response = await KnowledgeBaseAPI.create(payload);
      commit(types.default.ADD_KNOWLEDGE_BASE, response.data);
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { creatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  updateKnowledgeBaseArticle: async function updateCannedResponse(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { updatingItem: true });
    try {
      const payload = {
        knowledge_base: updateObj,
      };
      const response = await KnowledgeBaseAPI.update(id, payload);
      commit(types.default.EDIT_KNOWLEDGE_BASE, response.data);
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { updatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { updatingItem: false });
      return throwErrorMessage(error);
    }
  },

  deleteKnowledgeBaseArticle: async function deleteCannedResponse(
    { commit },
    id
  ) {
    commit(types.default.SET_CANNED_UI_FLAG, { deletingItem: true });
    try {
      await KnowledgeBaseAPI.delete(id);
      commit(types.default.DELETE_KNOWLEDGE_BASE, id);
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { deletingItem: true });
      return id;
    } catch (error) {
      commit(types.default.SET_KNOWLEDGE_BASE_UI_FLAG, { deletingItem: true });
      return throwErrorMessage(error);
    }
  },

  setSelectedKnowledgeBaseArticle: function setSelectedArticle(
    { commit },
    data
  ) {
    commit(types.default.SET_SELECTED_ARTICLE, data);
  },
};

const mutations = {
  [types.default.SET_KNOWLEDGE_BASE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_KNOWLEDGE_BASE]: MutationHelpers.set,
  [types.default.ADD_KNOWLEDGE_BASE]: MutationHelpers.create,
  [types.default.EDIT_KNOWLEDGE_BASE]: MutationHelpers.update,
  [types.default.DELETE_KNOWLEDGE_BASE]: MutationHelpers.destroy,
  [types.default.SET_SELECTED_ARTICLE](_state, data) {
    _state.selectedArticle = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
